export interface Entite {
    name: string,
    order: number,
    preuves: Array<Preuve>
    preuveObligatoire?: Preuve
    vitesseBase: number
    vitesseToPlayer: number
    santeMental: number
    santeMentalPouvoir: number
    checks: Array<string>,
    sidePreuves?: Array<string>
}


export type Preuve = "Dots" | "Ecriture" | "UV" | "SpiritBox" | "Orbe" | "Temperature" | "EMF"



export const entitesList : Array<Entite> = [
    {
        name: "Esprit",
        order: 1,
        preuves: ["Ecriture", "EMF", "SpiritBox"],
        vitesseBase: 1.7,
        vitesseToPlayer: 2.8,
        santeMental: 50,
        santeMentalPouvoir: 50,
        checks: ["Encens l'empeche d'attaqué pendant 180s (utilisé à moins de 3m)"],
        sidePreuves: ["NormalSpeedNoHunt", "NormalSpeedHunt"]
    },
    {
        name: "Spectre",
        order: 2,
        preuves: ["Dots", "EMF", "SpiritBox"],
        vitesseBase: 1.7,
        vitesseToPlayer: 2.8,
        santeMental: 50,
        santeMentalPouvoir: 50,
        checks: ["Ne marche pas dans le sel", "Se tp sur un joueur (EMF 2 ou 5 sur le joueur)"],
        sidePreuves: ["NormalSpeedNoHunt", "NormalSpeedHunt"]
    },
    {
        name: "Fantôme",
        order: 3,
        preuves: ["Dots", "SpiritBox", "UV"],
        vitesseBase: 1.7,
        vitesseToPlayer: 2.8,
        santeMental: 50,
        santeMentalPouvoir: 50,
        checks: ["N'apparait pas sur les photos (elles ne sont pas brouillées)", 
            "Photo pendant événement paranomal le fait disparaitre", 
            "Invisble pendant au moins une seconde entre chaque clignotement",
            "Déplacement vers un joueur aléatoire (EMF 2 à son point de départ (comme Banshee))"],
        sidePreuves: ["NormalSpeedNoHunt", "NormalSpeedHunt"]
    },
    {
        name: "Poltergeist",
        order: 4,
        preuves: ["Ecriture", "SpiritBox", "UV"],
        vitesseBase: 1.7,
        vitesseToPlayer: 2.8,
        santeMental: 50,
        santeMentalPouvoir: 50,
        checks: ["Peut lancer plusieurs objets en meme temps",
                "Perte de 2% de santé mentale par objet lancé avec son pouvoir",
                "En chasse, 100% change de lancé un objet a proximité contre 50% les autres",
                "Objets lancé 2x plus fort",
                "EMF 2 ou 3 par objet jeté (pouvoir)"
        ],
        sidePreuves: ["NormalSpeedNoHunt", "NormalSpeedHunt"]
    },
    {
        name: "Banshee",
        order: 5,
        preuves: ["Dots", "Orbe", "UV"],
        vitesseBase: 1.7,
        vitesseToPlayer: 2.8,
        santeMental: 50,
        santeMentalPouvoir: 50,
        checks: ["Cible un joueur au hasard qui devient sa proie (recommence à la mort du joueur)", 
            "67% chance de se déplacer vers sa cible hors chasse (comme fantôme)(pas à travers les étages excepté Point Hope ou Bleasdale si l'entite est a la cave)",
            "La cible perd 15% de santé mentale lors d'événement (touché)",
            "Chasse uniquement la cible (les autres sont invincibles), sinon agis comme une enttié lambda",
            "Privilégie les événements chantants",
            "33% de chances de faire un cri au micro parabolique",
            "Ne peut pas changer de salle favorite"
        ],
        sidePreuves: ["NormalSpeedNoHunt", "NormalSpeedHunt"]
    },
    {
        name: "Djinn",
        order: 6,
        preuves: ["Temperature", "EMF", "UV"],
        vitesseBase: 1.7,
        vitesseToPlayer: 2.8,
        santeMental: 50,
        santeMentalPouvoir: 50,
        checks: ["Ne peut éteindre le dijoncteur (peut le faire sauter en allumant une lumiere de trop)", 
            "Pouvoir : Draine 25% de santé mentale à tous les joueurs < 3 mètres ou dans la même pièce. EMF 2 à 5 au dijoncteur",
            "Pas de Pouvoir si dijoncteur éteint ou cassé",
            "Chasse : Accélère instatanément à 2.5m/s vers le joueur (visible a plus de 3m) si le dijoncteur allumé"
        ],
        sidePreuves: ["NormalSpeedNoHunt", "ExtremeFastSpeedHunt"]
    },
    {
        name: "Cauchemard",
        order: 7,
        preuves: ["Ecriture", "Orbe", "SpiritBox"],
        vitesseBase: 1.7,
        vitesseToPlayer: 2.8,
        santeMental: 40,
        santeMentalPouvoir: 60,
        checks: ["Ne peut pas allumer les lumières mais peut allumer les radios, les téléviseurs, les ordinateurs et le disjoncteur.", 
            "Peut éteindre une lumière instantanément qu'un joueur vient d'allumer à moins de 4 mètres d'elle. Le joueur ne peut pas forcer ce pouvoir en spammant les lumières, il faut attendre un minimum de 10 secondes entre chaque touche de l’interrupteur ou qu'un autre joueur éteigne la lumière.",
            "A plus de chances de réaliser un événement brisant les lumières.",
            "A plus de chances de choisir de se déplacer dans une pièce éteinte plutôt qu'une pièce allumée.",
            "N’hésitera pas à changer de salle et à chasser d’une autre pièce si sa pièce favorite est allumée"
        ],
        sidePreuves: ["NormalSpeedNoHunt", "NormalSpeedHunt"]
    },
    {
        name: "Revenant",
        order: 8,
        preuves: ["Ecriture", "Orbe", "Temperature"],
        vitesseBase: 1,
        vitesseToPlayer: 3,
        santeMental: 50,
        santeMentalPouvoir: 50,
        checks: ["Très lent lorsqu'il ne sait pas où est le joueur, très rapide lorsqu'il sait où est le joueur.", 
            "S'il perd la position du joueur, il ralentira progressivement jusqu’à sa vitesse initiale.",
            "Ralenti quand on brûle l'encens avant de reprendre sa vitesse de base ou son accélération s'il sait où est un joueur."
        ],
        sidePreuves: ["LowSpeedNoHunt", "ExtremeFastSpeedHunt"]
    },
    {
        name: "Ombre",
        order: 9,
        preuves: ["Ecriture", "EMF", "Temperature"],
        vitesseBase: 1.7,
        vitesseToPlayer: 2.8,
        santeMental: 35,
        santeMentalPouvoir: 35,
        checks: ["A tendance à peu interagir.", 
            "Ne peut pas interagir, souffler les bougies, attaquer, écrire, bouger d'objets ou de porte si un joueur se trouve dans sa pièce. Elle peut toujours se déplacer ou effectuer un événement cependant.",
            "Ne peut pas faire d'EMF 3 quand on est dans sa salle.",
            "A beaucoup plus de chances d'effectuer l'événement paranormal Mist",
            "Si manifestation, elle a beaucoup plus de chances d'utiliser la forme d'ombre.",
            "Avec 100% de santé mentale, l'Ombre a 0% de chances de faire un événement. La probabilité augmente de 2% par % de santé mentale perdu.",
            "Ne peut pas chasser si un joueur se trouve dans sa pièce."
        ],
        sidePreuves: ["NormalSpeedNoHunt", "NormalSpeedHunt"]
    },
    {
        name: "Démon",
        order: 10,
        preuves: ["Ecriture", "UV", "Temperature"],
        vitesseBase: 1.7,
        vitesseToPlayer: 2.8,
        santeMental: 70,
        santeMentalPouvoir: 100,
        checks: ["Le délai minimum entre 2 chasses normales est de 20 secondes (au lieu de 25) sans encens.", 
            "L'encens l'empêche de chasser pendant 60 secondes (au lieu de 90).",
            "Le crucifix a une portée multipliée par x1.5 donc T1 4.5m, T2 6m et T3 7.5m.",
            "Il aura tendance à chasser plus fréquemment."
        ],
        sidePreuves: ["NormalSpeedNoHunt", "NormalSpeedHunt"]
    },
    {
        name: "Yurei",
        order: 11,
        preuves: ["Dots", "Orbe", "Temperature"],
        vitesseBase: 1.7,
        vitesseToPlayer: 2.8,
        santeMental: 50,
        santeMentalPouvoir: 50,
        checks: ["Le pouvoir du Yurei est de fermer UNE porte autour de lui sans évènement paranormal.", 
            "Il peut faire une double interaction sur la porte (pouvoir), que vous pouvez visualiser avec l’EMF Tier 3.",
            "Le Yurei vous enlèvera 15% de santé mentale en faisant son pouvoir si vous êtes proche de lui.",
            "Brûler un encens dans sa salle favorite l’y piègera pendant 90 sec."
        ],
        sidePreuves: ["NormalSpeedNoHunt", "NormalSpeedHunt"]


    },
    {
        name: "Oni",
        order: 12,
        preuves: ["Dots", "EMF", "Temperature"],
        vitesseBase: 1.7,
        vitesseToPlayer: 2.8,
        santeMental: 50,
        santeMentalPouvoir: 50,
        checks: ["A tendance à beaucoup interagir, surtout avec des joueurs à proximité.", 
            "Clignotement rapide, il est visible plus souvent qu'invisible pendant les chasses. Ne peut pas être invisible plus de 0.5s.",
            "Ne peut pas effectuer l'événement Mist",
            "A tendance à utiliser la forme complète pour les événements paranormaux.",
            "Enlève 20% de santé mentale au lieu de 10% lors d'un événement si le joueur ciblé entre en collision avec lui."
        ],
        sidePreuves: ["NormalSpeedNoHunt", "NormalSpeedHunt"]

    },
    {
        name: "Yokai",
        order: 13,
        preuves: ["Dots", "Orbe", "SpiritBox"],
        vitesseBase: 1.7,
        vitesseToPlayer: 2.8,
        santeMental: 50,
        santeMentalPouvoir: 80,
        checks: ["Le Yokai attaque à partir de 80% de santé mentale grâce à son pouvoir qui peut s’activer si vous parlez à côté de lui et sera du coup proche du joueur à ce moment là", 
            "Il sera plus actif si vous parlez à côté de lui.",
            "En chasse, il ne vous entendra pas ni votre matériel électronique au delà de 2,5-3m et vous perdra très facilement.",
            "Avec la boîte à musique, il peut commencer à se manifester plus proche de la boîte que les autres entités.",
        ],
        sidePreuves: ["NormalSpeedNoHunt","NormalSpeedHunt"]

    },
    {
        name: "Hantu",
        order: 14,
        preuves: ["Orbe", "UV", "Temperature"],
        preuveObligatoire: "Temperature",
        vitesseBase: 1.7,
        vitesseToPlayer: 0,
        santeMental: 50,
        santeMentalPouvoir: 50,
        checks: ["Ne peut pas allumer le disjoncteur.", 
            "A 50% plus de chances d'éteindre le disjoncteur que les autres entités.",
            "Il aura un souffle glacial pendant les chasses dans sa salle si le disjoncteur est allumé.",
            "Si le disjoncteur est éteint, il génère un souffle glacial durant la chasse dans toutes les pièces. Les joueurs décédés ne peuvent pas voir ce souffle.",
            "Il n'accélère pas à la vue du joueur, sa vitesse étant basée sur la température des pièces qu'il traverse. (Attention les fantomes refroidissent la salle où ils se trouvent, même en chasse)"
        ],
        sidePreuves: ["LowSpeedNoHunt", "FastSpeedNoHunt", "ExtremeFastSpeedHunt"]
    },
    {
        name: "Goryo",
        order: 15,
        preuves: ["Dots", "EMF", "UV"],
        preuveObligatoire: "Dots",
        vitesseBase: 1.7,
        vitesseToPlayer: 2.8,
        santeMental: 50,
        santeMentalPouvoir: 50,
        checks: ["Ne peut pas changer de pièce favorite (sauf si on utilise le vœu de santé mentale à la Patte de singe).", 
            "Ne peut que faire des déplacements courts avec une distance parcourue maximale de 5 mètres par déplacement.",
            "Ses D.O.T.S. ne sont visibles qu'à la caméra et si personne ne se trouve dans sa pièce.",
            "Il ne peut sortir qu'à 5 m de sa salle (hors chasse)."
        ],
        sidePreuves: ["NormalSpeedNoHunt", "NormalSpeedHunt"]

    },
    {
        name: "Myling",
        order: 16,
        preuves: ["Ecriture", "EMF", "UV"],
        vitesseBase: 1.7,
        vitesseToPlayer: 2.8,
        santeMental: 50,
        santeMentalPouvoir: 50,
        checks: ["Ses bruits de pas ne sont audibles qu'à moins de 12 mètres au lieu de 20m pour un fantome normal. (De façon progressive)", 
            " Attention, le matériel électronique ne clignote pas si vous n'êtes pas au même étage que lui mais vous pouvez entendre ses pas au dessus/dessous de vous.",
            "Produit des sons paranormaux plus fréquemment au micro parabolique.",
            "Ses bruits normaux (chant, grognement, rire ect) en chasse ne sont pas différents des autres entités."
        ],
        sidePreuves: ["NormalSpeedNoHunt", "NormalSpeedHunt"]

    },
    {
        name: "Onryo",
        order: 17,
        preuves: ["Orbe", "SpiritBox", "Temperature"],
        vitesseBase: 1.7,
        vitesseToPlayer: 2.8,
        santeMental: 60,
        santeMentalPouvoir: 100,
        checks: ["Tente une chasse dans un délai de 1 à 6 secondes chaque fois qu'il souffle 3 flammes. Les flammes empêchant les chasses et celles soufflées pendant les chasses comptent aussi.", 
            "S'il tente une chasse à moins de 4 mètres d'une flamme, il soufflera cette flamme au lieu de chasser. La flamme a toujours la priorité sur le crucifix pour empêcher ses chasses",
            "Il peut brûler le crucifix s'il chasse en dehors du rayon d'action de la flamme.",
            "Le chandelier compte comme une seule flamme malgré les 3 bougies.",
            "Les bougies allumées dans la maison compte pour le pouvoir de l’onryo.",
            "Les Bougies de la Chappelle de Sunny Meadows comptent."
        ],
        sidePreuves: ["NormalSpeedNoHunt", "NormalSpeedHunt"]

    },
    {
        name: "Jumeaux",
        order: 18,
        preuves: ["EMF", "SpiritBox", "Temperature"],
        vitesseBase: 1.5,
        vitesseToPlayer: 2.5,
        santeMental: 50,
        santeMentalPouvoir: 50,
        checks: ["N'est en réalité qu'une seule entité.", 
            "A la possibilité de faire une double interaction décalée de 0.5 s, l'une à moins de 3 mètres de sa position et l'autre jusqu'à 16 mètres.",
            "A 50% de chances de chasser depuis sa position actuelle (jumeau lent) et 50% de chances depuis l'endroit où la dernière interaction à distance s'est produite (jumeau rapide).",
            "Le crucifix ne fonctionne que sur le vrai jumeau, le faux jumeau peut chasser depuis la zone de l'interaction à distance.",
            "Il a 50% de chance de choisir l'une ou l'autre entité et peut donc être plusieurs fois la même."
        ],
        sidePreuves: ["LowSpeedNoHunt", "FastSpeedNoHunt", "NormalSpeedHunt"]
    },
    {
        name: "Raiju",
        order: 19,
        preuves: ["Dots", "EMF", "Orbe"],
        vitesseBase: 1.7,
        vitesseToPlayer: 2.8,
        santeMental: 50,
        santeMentalPouvoir: 65,
        checks: ["Pendant les chasses, s'il se trouve proche d'un appareil électronique actif au même étage, sa vitesse augmente. Ceci dans un rayon de: 6 mètres pour une petite map, 8 mètres pour une moyenne, 10 mètres pour une grande.", 
            "Perturbe les appareils électroniques jusqu'à 15 mètres au lieu de 10 pendant les manifestations et chasses. Attention à ne pas le confondre donc avec un Myling.",
            "Il ira à 2,5 m/s instantanément et reprendra une vitesse normale en dehors du rayon d'un objet électronique allumé.",
            "Il n'ira pas au dessus de 2,5m/s en voyant le joueur s'il est proche d'un objet allumé mais accélèrera jusqu'à 2,8m/seconde à la vue du joueur en dehors de ce rayon.",
            "La télé, les radios, les lampes de la maison et le disjoncteur ne sont pas pris en compte pour son pouvoir.",
            "La lampe de poche allumée dans votre main, dans votre ceinture ou au sol et pris en compte en permanence.",
            "Tous les équipements dit électronique allumés sont pris en compte pour son pouvoir, posés au sol ou en main."
        ],
        sidePreuves: ["FastSpeedNoHunt", "NormalSpeedNoHunt", "NormalSpeedHunt", "ExtremeFastSpeedHunt"]
    },
    {
        name: "Obake",
        order: 20,
        preuves: ["EMF", "Orbe", "UV"],
        preuveObligatoire: "UV",
        vitesseBase: 1.7,
        vitesseToPlayer: 2.8,
        santeMental: 50,
        santeMentalPouvoir: 50,
        checks: ["Possède 25% de chances de ne pas laisser d'empreintes digitales.", 
            "Possède 25% de chance de laisser son empreinte à 6 doigts, à 5 sur le clavier et à 2 sur l'interrupteur.",
            "Il peut réduire le temps restant d’affichage par 2 de ses empreintes à tous moment.",
            "Il a 6,66% de chance de changer de skin à chaque clignotement lors d’une chasse mais il ne peut pas changer de sexe et Sadako pourra changer en ses 3 formes différentes durant la chasse.",
            "Change de forme au minimum 1 fois par chasse."
        ],
        sidePreuves: ["NormalSpeedNoHunt", "NormalSpeedHunt"]

    },
    {
        name: "Mimic",
        order: 21,
        preuves: ["SpiritBox", "Temperature", "UV", "Orbe"],
        vitesseBase: 1.7,
        vitesseToPlayer: 2.8,
        santeMental: 50,
        santeMentalPouvoir: 50,
        checks: ["Copie une autre entité et ses caractéristiques toutes les 30 à 120 secondes en dehors des chasses.", 
            "Ne copie pas les preuves des entités imitées mais toutes les caractéristiques, pouvoirs et comportements.",
            "Si le Thayé est imité, il aura un âge aléatoire et ne vieillira pas.",
            "Possède Orbes fantomatiques, même sur une difficulté avec 0 preuve.",
            "Il ne change pas d'entité en chasse",
            "Il ne change pas de skin en changeant d'entités.",
            "Il peut copier le joueur ou un autre mimic et sera inactif à ce moment là.",
            "Il est le seul  pouvoir à laisser une empreinte sur la porte d'entrée."
        ]
    },
    {
        name: "Moroi",
        order: 22,
        preuves: ["SpiritBox", "Temperature", "Ecriture"],
        preuveObligatoire: "SpiritBox",
        vitesseBase: 1.5,
        vitesseToPlayer: 3.71,
        santeMental: 50,
        santeMentalPouvoir: 50,
        checks: ["Maudit le joueur recevant une réponse à la Spirit Box ou un chuchotement au micro parabolique.", 
            "Un joueur maudit perd  2 fois plus vite sa santé mentale donc 14% en solo et 28%/min en multi même dans la lumière. (Petite Map et en Pro minimum)",
            "La malédiction se soigne en prenant une pilule calmante.",
            "L'encens le désoriente 7,5 secondes au lieu de 5 pendant une chasse.",
            "Manger des pilules le fait ralentir hors et pendant la chasse.",
            "La malédiction n'est effective que dans la maison",
            "Ressusciter un joueur annule la malédiction s'il était maudit."
        ],
        sidePreuves: ["FastSpeedNoHunt", "LowSpeedNoHunt", "ConstantSpeedHunt"]
    },
    {
        name: "Deogen",
        order: 23,
        preuves: ["Dots", "Ecriture", "SpiritBox"],
        preuveObligatoire: "SpiritBox",
        vitesseBase: 3,
        vitesseToPlayer: 0.4,
        santeMental: 40,
        santeMentalPouvoir: 40,
        checks: ["Le deogen sait en permanence où sont les joueurs avec ou sans équipement donc impossible de se cacher.", 
            "33% de chance de faire un cri spécial à la spirit à moins de 1m de lui.",
            "Il est très rapide loin du joueur même sans le voir et devient très lent à proximité du joueur.",
            "Il a plus de chance de mettre l'écriture et les DOTS.",
            "Il clignote aussi très vite comme l’Oni.",
        ],
        sidePreuves: ["FastSpeedNoHunt", "LowSpeedHunt", "ExtremeFastSpeedHunt"]
    },
    {
        name: "Thaye",
        order: 24,
        preuves: ["Dots", "Ecriture", "Orbe"],
        vitesseBase: 2.75,
        vitesseToPlayer: 2.75,
        santeMental: 75,
        santeMentalPouvoir: 75,
        checks: ["Au bout de 1 à 2 minutes, il tente de vieillir. Si un joueur se trouve dans sa pièce, son âge augmentera de 1. Sinon, il attend 30 secondes avant de tenter à nouveau.", 
            "2x plus de chance de faire des interactions à son âge initial que les autres entités, devient de moins en moins actif lorsque son âge augmente et fera - de  50% d'interaction à son âge max.",
            "A plus de chances d'interagir avec le Livre d'écriture fantomatique et le Projecteur D.O.T.S.",
            "Il est possible de savoir s’il vieilli grâce à la Ouija. La question “quel âge avez vous ?” donnera l’âge actuel de l’entité.",
            "Il vieillira jusqu'à 10 fois maximum par partie.",
            "Le Thayé n’accélère pas pendant la chasse. Sa vitesse étant basée sur son âge, elle n’est pas influencée par la vue du joueur."
        ],
        sidePreuves: ["FastSpeedNoHunt", "LowSpeedNoHunt", "ConstantSpeedHunt"]
    },
]